<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BHcvsU/tc-custom/9781429906203.jpg?1731166618844" alt="This image is the cover for the book How the Rich Get Thin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How the Rich Get Thin
      </h1>
      <p class="bookDescription body article font2">
        <p>You know the ones: the women walking down Park or Fifth Avenues on Manhattan's Upper East Side. Hermes handbag on the arm. Hair just so.  Sleek and groomed as greyhounds. <i>How The Rich Get Thin</i>, from one of New York's premier weight control doctors, reveals the secrets of how the successful and rich get and stay thin.  With a quick-start two week program that the dieter later builds on to keep losing weight and eventually to maintain their shape, <i>How The Rich Get Thin </i>includes:<br/><br/>--Meal plans high in protein, omega-3 fats and complex carbohydrates<br/>--Calcium, through food rather than supplements, in the maximum amount the body can absorb at a time<br/>--A morning exercise program as an adjunct to eating<br/>--The Stop Watch method to curb food cravings: any craving can be stopped within just 15 minutes<br/>--How to eat at fabulous restaurants, for business or pleasure, and keep losing weight.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jana Klauer
      </h2>
      
      <p class="authorDescription body article"><P>Jana Klauer, M.D., is the national director of nutrition at Equinox in New York City. She is also a research fellow at the New York Obesity Research Center of St. Luke's-Roosevelt Hospital and is actively involved in clinical research on obesity. She is in private practice in New York City, where she lives.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Griffin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0cfdbb2f